export const ALL_TOOLS = {
    "Core": [
      { id: 'get_current_time', label: 'Current time' },
      { id: 'python_executor', label: 'Python' }
    ],
    "Memory": [
      { id: 'remember_this', label: 'Remember' },
      { id: 'recall_memory', label: 'Recall' }
    ],
    "File System": [
      { id: 'list_files', label: 'List files' },
      { id: 'read_file', label: 'Read file' },
      { id: 'write_file', label: 'Write file' }
    ],
    "Web Research": [
      { id: 'web_search', label: 'Web search Single' },
      { id: 'multi_web_search', label: 'Web search Multiple' },
      { id: 'intelligent_web_reader', label: 'Intelligent web reader' },
      { id: 'summarize_urls', label: 'Summarize URLs' }, 
    ],
    "Interactive Browser": [
      { id: 'open_url', label: 'Open URL' },
      { id: 'click_element', label: 'Click element' },
      { id: 'type_text', label: 'Type text' },
      { id: 'list_interactive_elements', label: 'List interactive elements' },
      { id: 'close_browser', label: 'Close browser' }
    ]
  };